import { render, staticRenderFns } from "./ApplyDocumentOtm.vue?vue&type=template&id=7addba82&scoped=true&"
import script from "./ApplyDocumentOtm.vue?vue&type=script&lang=js&"
export * from "./ApplyDocumentOtm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7addba82",
  null
  
)

export default component.exports